var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.288,
    height: 15.5,
    viewBox: "0 0 18.288 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(-0.25 -1.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25298",
    "data-name": "Path 25298",
    d: "M13.209,19.578V18.052A3.052,3.052,0,0,0,10.157,15h-6.1A3.052,3.052,0,0,0,1,18.052v1.526",
    transform: "translate(0 -2.843)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2019",
    "data-name": "Ellipse 2019",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(4 2.735)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25299",
    "data-name": "Path 25299",
    d: "M22.289,19.609V18.083A3.052,3.052,0,0,0,20,15.13",
    transform: "translate(-4.502 -2.874)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25300",
    "data-name": "Path 25300",
    d: "M16,3.13a3.052,3.052,0,0,1,0,5.914",
    transform: "translate(-3.554 -0.031)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.af794e50a470e894c2448a48a9402333.svg";
export { ForwardRef as ReactComponent };